import { render } from "./IconDownload.vue.js?vue&type=template&id=0d246310!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconDownload.vue?vue&type=template&id=0d246310"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__